<template>
  <div
    class="h-full fixed bg-white right-0 z-10 md:flex flex-row hidden"
    style="width: 424px"
  >
    <!-- <div
            class="h-full flex justify-center items-center p-2 cursor-pointer hover:border-white-dark border-r border-transparent transition-all "
        >
            <simple-arrow-icon
                :fillClass="'fill-grey'"
                class="w-6 h-6 transform transition-all rotate-90 "
            />
        </div> -->
    <div
      class="
                pt-24
                flex flex-col
                w-full
                justify-start
                items-center
                overflow-auto
                scrollbar
            "
      style="height: calc(100% - 60px)"
    >
      <avatar-bubble
        class="w-20 h-20"
        style="min-width: 80px; min-height: 80px"
        :isEditable="true"
        :user="GET_USER"
        @emitDelete="
          GET_USER.avatar = null;
          UPLOAD_AVATAR();
        "
        @change="
          (file) => {
            GET_USER.avatar = null;
            UPLOAD_AVATAR(file);
          }
        "
      />

      <h1 class="mt-4 font-semibold text-xl text-primary">
        {{ GET_USER.full_name }}
      </h1>
      <div class="grid grid-cols-2 gap-5 mt-10">
        <sidebar-link
          :text="'Meine Dokumente'"
          @click="$router.push({ name: 'Documents' })"
          :isActive="$route.name == 'Documents'"
        >
          <file-icon
            class="h-8 w-6"
            :fillClass="
              $route.name == 'Documents' ? 'fill-primary' : 'fill-grey'
            "
          />
        </sidebar-link>
        <sidebar-link
          :text="'Mein Profil'"
          @click="$router.push({ name: 'Profile' })"
          :isActive="$route.name == 'Profile'"
        >
          <profile-icon
            :fillClass="$route.name == 'Profile' ? 'fill-primary' : 'fill-grey'"
          />
        </sidebar-link>
        <sidebar-link
          v-if="GET_USER.is_lecturer"
          :text="'Dozentenbereich'"
          @click="$router.push({ name: 'LecturerDashboard' })"
          :isActive="$route.name == 'LecturerDashboard'"
        >
          <dashboard-icon
            class="w-8 h-8"
            :fillClass="
              $route.name == 'LecturerDashboard' ? 'fill-primary' : 'fill-grey'
            "
          />
        </sidebar-link>
        <sidebar-link
          :text="'Einstellungen'"
          @click="$router.push({ name: 'Settings' })"
          :isActive="$route.name == 'Settings'"
        >
          <settings-icon
            class="w-8 h-8"
            :fillClass="
              $route.name == 'Settings' ? 'fill-primary' : 'fill-grey'
            "
          />
        </sidebar-link>
        <sidebar-link
          v-if="false"
          :text="'Meine Gutscheine'"
          @click="$router.push({ name: 'Coupons' })"
        >
          <coupon-icon
            :fillClass="'fill-grey'"
            class="transform scale-125 mb-1 mt-3"
          />
        </sidebar-link>
      </div>
      <div class="mt-2 mb-3 bg-white-dark h-px" style="width: 336px" />
      <div class="w-full pl-6 mb-24" v-if="GET_LAST_VIDEOS.length > 0">
        <div class="text-black font-semibold text-base mb-3">
          Weiterschauen
        </div>

        <div
          class="
                        w-full
                        bg-white-dark
                        px-5
                        py-2
                        hover:bg-primary-lightest
                        transition-colors
                        flex flex-row
                        justify-between
                        items-center
                        rounded-l-md
                        mb-3
                        cursor-pointer
                    "
          v-for="(video, index) in GET_LAST_VIDEOS"
          :key="index"
          @click="showVideo(video)"
        >
          <div style="width: calc(100% - 45px)">
            <p
              class="
                                w-full
                                overflow-hidden
                                whitespace-nowrap
                                overflow-ellipsis
                                text-base text-black
                                mb-2
                            "
            >
              {{ `${index + 1}. ${video.name}` }}
            </p>
            <div
              class="
                                flex flex-row
                                justify-start
                                items-center
                                w-full
                            "
            >
              <arrow-icon
                :fillClass="'fill-primary'"
                class="transform -rotate-90 mr-1"
              />
              <div
                style="width: calc(100% - 30px)"
                class="
                                    text-grey text-sm
                                    overflow-ellipsis overflow-hidden
                                    whitespace-nowrap
                                    select-none
                                "
              >
                {{ `${video.slide.minutes} Min.` }}
              </div>
            </div>
          </div>
          <icon-container
            class="transform rotate-90"
            :icon="'SimpleArrowIcon'"
            :iconSize="'4'"
            iconFill="fill-primary"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="w-screen md:hidden absolute bottom-0 right-0 z-50 h-14">
    <div
      class="
                w-full
                bg-primary
                h-full
                flex flex-row
                items-center
                justify-center
            "
    >
      <sidebar-link-small
        :link="link"
        v-for="link in state.links"
        :key="link.id"
      />
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, reactive } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import {
  AUTH_USER_TYPES,
  LAST_VIDEOS_TYPES,
  MEDIA_TYPES,
  STORE_TYPES,
} from "../../store/types";
import AvatarBubble from "../helper/AvatarBubble.vue";
import IconContainer from "../helper/IconContainer.vue";
import SidebarLink from "./SidebarLink.vue";
import SidebarLinkSmall from "./SidebarLinkSmall.vue";
import DashboardIcon from "../icons/DashboardIcon.vue";

export default defineComponent({
  name: "Sidebar",
  components: {
    AvatarBubble,
    SidebarLink,
    IconContainer,
    SidebarLinkSmall,
    DashboardIcon,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const state = reactive({
      links: [
        {
          id: 1,
          icon: "MyCourseIcon",
          name: "Meine Kurse",
          link: { name: "Dashboard" },
        },
        {
          id: 2,
          icon: "FileIcon",
          name: "Dokumente",
          link: { name: "Documents" },
        },
        {
          id: 3,
          icon: "ProfileIcon",
          name: "Mein Profil",
          link: { name: "Profile" },
        },
        {
          id: 4,
          icon: "SettingsIcon",
          name: "Einstellungen",
          link: { name: "Settings" },
        },
      ],
    });

    function UPLOAD_AVATAR(file) {
      store.dispatch(`${STORE_TYPES.MEDIA}/${MEDIA_TYPES.UPLOAD_AVATAR}`, {
        avatar: file,
      });
    }
    function showVideo(video) {
      const courseId = video.id;
      const slideId = video.slide.id;
      localStorage.setItem("goToSlideId", slideId);
      router.push({
        name: "CourseShow",
        params: { id: courseId },
      });
    }
    function openWebsite() {
      window.open("https://www.way-yoga.de/", "_blank");
    }

    const GET_USER = computed(
      () =>
        store.getters[`${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.GET_USER}`]
    );
    const GET_LAST_VIDEOS = computed(
      () =>
        store.getters[
          `${STORE_TYPES.LAST_VIDEOS}/${LAST_VIDEOS_TYPES.GET_LAST_VIDEOS}`
        ]
    );
    return {
      state,
      GET_USER,
      showVideo,
      UPLOAD_AVATAR,
      GET_LAST_VIDEOS,
      openWebsite,
    };
  },
});
</script>
